module.exports = __webpack_public_path__ + "assets/img/lithuania.2a2e8d88.png";